/**
 * Products mega menu
 */
 var component_products_mega_menu = function(args) {

  // setup args
  var mega_menu = args.mega_menu;

  // validate
  if (!mega_menu) {
    console.log('Invalid mega menu');
    return;
  }

  var mega_menu_wrap = mega_menu.querySelector('.products-mega-menu__wrap');
  var desktop_min_width = args.desktop_min_width;
  var mobile_max_width = args.mobile_max_width;
  var close_btn = mega_menu.querySelector('.products-mega-menu__close-btn');
  var mega_menu_li_parent = mega_menu.parentElement;
  var mega_menu_links = mega_menu.getElementsByTagName('a');
  var last_link = mega_menu_links[mega_menu_links.length - 1];

  /**
   * Calculate and set menu max height (on desktop)
   */
  function set_menu_max_height() {
    let headerHeight = document.getElementById('masthead').offsetHeight;
    mega_menu.style.maxHeight = window.innerHeight - headerHeight - 32 + 'px';
  }

  /**
   * Masonry layout (Colcade)
   */
  var masonry = null;

  function init_masonry_layout(wrap) {
    if (window.matchMedia('(min-width: ' + desktop_min_width + 'px)').matches) {
      masonry = new Colcade(wrap, {
        columns: '.products-mega-menu__col',
        items: '.products-mega-menu__cat-section'
      });
    } else if (masonry) {
      masonry.destroy();
      masonry = null;
    }
  }

  // Close button handler — always attached.
  // The button is hidden on desktop via CSS (display: none), so this only
  // fires on mobile. Attaching unconditionally avoids issues when the page
  // loads at desktop width and the user later switches to mobile viewport.
  if (close_btn) {
    close_btn.addEventListener('click', (e) => {
      e.stopPropagation();
      mega_menu.setAttribute('aria-hidden', 'true');
      mega_menu_li_parent.setAttribute('aria-expanded', 'false');
    });
  }

  // Focus trap handler for mobile mega menu
  function focusTrapHandler(e) {
    if (e.key !== 'Tab') {
      return;
    }

    if (e.shiftKey) {
      if (document.activeElement === close_btn) {
        last_link.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === last_link) {
        close_btn.focus();
        e.preventDefault();
      }
    }
  }

  // Respond dynamically to viewport changes
  var mobileQuery = window.matchMedia('(max-width: ' + mobile_max_width + 'px)');

  function handleViewportChange(e) {
    if (e.matches) {
      // mobile: enable focus trap, reset inline max-height
      document.addEventListener('keydown', focusTrapHandler);
      mega_menu.removeAttribute('style');
    } else {
      // desktop: disable focus trap, set max-height
      document.removeEventListener('keydown', focusTrapHandler);
      set_menu_max_height();
    }
  }

  mobileQuery.addEventListener('change', handleViewportChange);
  // Apply initial state
  handleViewportChange(mobileQuery);

  // Recalculate max-height on desktop resize
  window.addEventListener('resize', debounce(function () {
    if (window.matchMedia('(min-width: ' + desktop_min_width + 'px)').matches) {
      set_menu_max_height();
    }
  }, 250));

  /**
   * Init
   */
  function init() {
    init_masonry_layout(mega_menu_wrap);
    return;
  }
  init();

  // make the call chainable
  return this;
};
